import { apiClient } from "@/services/api";

export default {
  getTypes() {
    return apiClient.get("/pass-types");
  }
};
